import { render, staticRenderFns } from "./SpaceGuests.vue?vue&type=template&id=1c1a6614"
import script from "./SpaceGuests.vue?vue&type=script&lang=js"
export * from "./SpaceGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports